import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/gameTypes';

import {stateStructure} from './_stateStructure.js'

const initialState = Immutable.fromJS( stateStructure.game );

export default function game( state = initialState, action ){

	let _state = state.toJS();

	switch (action.type) {
		// 获取热门游戏
		case ACTION.GET_HOTGAME:{
			let hotGames = _.find(_state.hot, {platformId: action.extend}) || {};
			let hots = _.remove(_state.hot, (item) => item.platformId == action.extend);
			hotGames = {
				platformId: action.extend,
				list: action.result.data.list || []
			}
			hots.push(hotGames);
			switch(action.extend){
				case 1: _state.pt.hot = hots; break;
				case 3: _state.ag.hot = hots; break;
				case 2: _state.bbin.hot = hots; break;
			}
			return state.merge(_state)		
		}
		// 获取游戏分类列表
		case ACTION.GET_GAME_CATEGORIES:{
			_state.categories = action.result.data;
			return state.merge(_state)		
		}
		// 获取当前页游戏列表
		case ACTION.GET_GAME_LIST:{
			switch(action.extend){
				case 1: _state.pt.contents = action.result.data; break;
				case 3: _state.ag.contents = action.result.data; break;
				case 2: _state.bbin.contents = action.result.data; break;
			}
			return state.merge(_state)		
		}
		// 获取当前游戏平台的banner
		case ACTION.GET_BANNERS_FOR_GAME:{
			switch(action.extend){
				case 1: _state.pt.ads = action.result.data; break;
				case 3: _state.ag.ads = action.result.data; break;
				case 2: _state.bbin.ads = action.result.data; break;
			}
			return state.merge(_state)	
		}
		// 获取平台开始游戏的地址
		case ACTION.GET_PLATFORM_PLAYURL:{
			_state[action.extend].play_url = action.result.data.url;
			return state.merge(_state);	
		}
		// 注销用户
		case USER_ACTION.LOGOUT:{
			return initialState;
		}
		
		default:
      		return state;
	}
}